// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/tab/index.css
// module id = 453
// module chunks = 32